<!-- =========================================================================================
  File Name: CustomerEditTabInformation.vue
  Description: Customer Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/customer/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <!-- Avatar Row -->
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="center">{{ $t('sections.customer.section.personalInformation') }}</vs-divider>
          <div class="vx-row flex">
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.prefix')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.prefix') }}*</label>
                <v-select :clearable="true" :options="prefixOptions" :name="$t('sections.customer.dataForm.prefix')" :reduce="res => res.value" v-model="form.prefix" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.name") }}*</label>
                <vs-input type="text" class="w-full" v-model="form.name" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.customer.dataForm.surname')}}*</label>
                <vs-input type="text" class="w-full" v-model="form.surname" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.birthDay')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.birthDay') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.birthDay"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.idCardNumber')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.idCardNumber') }}*</label>
                <vs-input type="text" class="w-full"  v-model="form.idCardNumber"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.issueDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.issueDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.issueDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.expDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.expDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.expDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.occupation')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.occupation') }}</label>
                <vs-input type="text" v-model="form.career" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.position')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.position') }}</label>
                <vs-input type="text" v-model="form.position" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.affiliate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.affiliate') }}</label>
                <vs-input type="text" v-model="form.affiliate" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="center">{{ $t('sections.customer.section.contactInformation') }}</vs-divider>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.location')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.location') }}</label>
                <vs-input type="text" v-model="form.address.location" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.moo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alley" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.road" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="store" v-model="form.address.subDistrict" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="store" v-model="form.address.district" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="store" v-model="form.address.province" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="store" v-model="form.address.zipcode" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.locationDoc')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.locationDoc') }}</label>
                <vs-input type="text" v-model="form.address.locationDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumberDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.mooDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alleyDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.roadDoc" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="storeDoc" v-model="form.address.subDistrictDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="storeDoc" v-model="form.address.districtDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="storeDoc" v-model="form.address.provinceDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="storeDoc" v-model="form.address.zipcodeDoc" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.phone')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.phone') }}</label>
                <vs-input type="text" v-model="form.phone" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.mobile')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.mobile') }}</label>
                <vs-input type="text" v-model="form.mobile" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.email')" rules="email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.email') }}</label>
                <vs-input type="text" v-model="form.email" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.customer.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.customer.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import { DataStore } from 'vue-thailand-address';
import {IStatus} from "@/constants/interface";

const {mapActions: mapCustomerActions, mapState:  mapCustomerFields} = createNamespacedHelpers('Customer')
const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        birthDay: '',
        idCardNumber: '',
        issueDate: '',
        expDate: '',
        career: '',
        position: '',
        affiliate: '',
        address: {
          id: '',
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
          locationDoc: '',
          houseNumberDoc: '',
          mooDoc: '',
          alleyDoc: '',
          roadDoc: '',
          subDistrictDoc: '',
          districtDoc: '',
          provinceDoc: '',
          zipcodeDoc: ''
        },
        phone: '',
        mobile: '',
        email: '',
        status: IStatus.enabled
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      store: new DataStore(),
      storeDoc: new DataStore()
    }
  },
  computed: {
    ...mapCustomerFields(['status', 'surety']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      statusesOptions :'Master/statusesOptions',
    })
  },
  methods: {
    ...mapCustomerActions(['initializing', 'updateSurety', 'getSurety']),
    ...mapMasterActions(['getPrefixOptions']),
    async loadOptions() {
      const vm = this
      const { getPrefixOptions } = vm
      if(vm.prefixOptions.length === 0) await getPrefixOptions()
    },
    async initData() {
      const vm = this;
      const { getSurety } = vm
      await getSurety({form: {id: vm.$route.params.id}})
      const { surety } = vm
      const prefix =(surety.prefix ? surety.prefix.id : '')
      vm.form = {
        prefix,
        name: surety.name,
        surname: surety.surname,
        birthDay: vm.$options.filters.convYYYYMMDDToDDMMYYYY(surety.birthDay),
        idCardNumber: surety.idCardNumber,
        issueDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(surety.issueDate),
        expDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(surety.expDate),
        career: surety.career,
        position: surety.position,
        affiliate: surety.affiliate,
        address: {
          location: surety.address.location,
          houseNumber: surety.address.houseNumber,
          moo: surety.address.moo,
          alley: surety.address.alley,
          road: surety.address.road,
          subDistrict: surety.address.subDistrict,
          district: surety.address.district,
          province: surety.address.province,
          zipcode: surety.address.zipcode,
          locationDoc: surety.address.locationDoc,
          houseNumberDoc: surety.address.houseNumberDoc,
          mooDoc: surety.address.mooDoc,
          alleyDoc: surety.address.alleyDoc,
          roadDoc: surety.address.roadDoc,
          subDistrictDoc: surety.address.subDistrictDoc,
          districtDoc: surety.address.districtDoc,
          provinceDoc: surety.address.provinceDoc,
          zipcodeDoc: surety.address.zipcodeDoc
        },
        phone: surety.phone,
        mobile: surety.mobile,
        email: surety.email,
        status: surety.status
      }
    },
    async submit () {
      const vm = this
      const { updateSurety } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        updateSurety({
          id: vm.$route.params.id,
          form: {
            prefix: {id: vm.form.prefix || ''},
            name: vm.form.name,
            surname: vm.form.surname,
            birthDay: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.birthDay),
            idCardNumber: vm.form.idCardNumber,
            issueDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.issueDate),
            expDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.expDate),
            career: vm.form.career,
            position: vm.form.position,
            affiliate: vm.form.affiliate,
            address: {
              location: vm.form.address.location,
              houseNumber: vm.form.address.houseNumber,
              moo: vm.form.address.moo,
              alley: vm.form.address.alley,
              road: vm.form.address.road,
              subDistrict: vm.form.address.subDistrict,
              district: vm.form.address.district,
              province: vm.form.address.province,
              zipcode: vm.form.address.zipcode,
              locationDoc: vm.form.address.locationDoc,
              houseNumberDoc: vm.form.address.houseNumberDoc,
              mooDoc: vm.form.address.mooDoc,
              alleyDoc: vm.form.address.alleyDoc,
              roadDoc: vm.form.address.roadDoc,
              subDistrictDoc: vm.form.address.subDistrictDoc,
              districtDoc: vm.form.address.districtDoc,
              provinceDoc: vm.form.address.provinceDoc,
              zipcodeDoc: vm.form.address.zipcodeDoc
            },
            phone: vm.form.phone,
            mobile: vm.form.mobile,
            email: vm.form.email,
            status: vm.form.status
          },
          vm
        })
      })
    },
    reset () {
      const vm = this
      vm.initData()
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
}
</script>
